module.exports = __webpack_public_path__ + "img/appdops.c1307996.svg";